module.exports = __webpack_public_path__ + "assets/je-orange-lg-logo-baa9b2.svg";